import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { dataFormatter } from "../../constant/condition";
import "../Styles/Home.css";
import NotFound from "./NotFound";
import config from "../../config/Config";
import { Helmet } from "react-helmet";
import ListingHero from "./ListingHero";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { CardImageThumb } from "./CardImageThumb";

export default function SearchPage() {
  const location = useLocation();
  const [configuration, setConfiguration] = useState([]);
  const [imageLightboxSrc, setImageLightboxSrc] = useState(null);
  const { data } = location.state || {};
  const [activeTab, setActiveTab] = useState("blog");

  const toSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
  };

  function fetchConfiguration() {
    fetch(`${config.API_BLOG}configuration`)
      .then((result) => result.json())
      .then((res) => {
        setConfiguration(res);
      })
      .catch((err) => console.error("Error fetching configuration:", err));
  }

  useEffect(() => {
    fetchConfiguration();
  }, []);

  useEffect(() => {
    if (!data) return;
    const hasB = data.blog_posts?.length > 0;
    const hasT = data.tutorial_series?.length > 0;
    if (hasT && !hasB) setActiveTab("tutorial");
    if (hasB && !hasT) setActiveTab("blog");
  }, [data]);

  const metaTitle = configuration[0]?.default_meta_title;
  const metaKeywords = configuration[0]?.default_meta_keywords;
  const metaDescription = configuration[0]?.default_meta_description;

  const siteLabel =
    configuration[0]?.default_meta_title?.split("|")[0]?.trim() || "iLearnings";

  const renderHTML = (rawHTML) => {
    return { __html: rawHTML };
  };

  const hasBlogPosts = data?.blog_posts?.length > 0;
  const hasTutorialSeries = data?.tutorial_series?.length > 0;
  const blogCount = data?.blog_posts?.length || 0;
  const tutCount = data?.tutorial_series?.length || 0;

  return (
    <div className="mb-4 page-shell home-page">
      {hasBlogPosts || hasTutorialSeries ? (
        <div>
          <Helmet>
            <meta name="title" content={metaTitle} />
            <meta name="keywords" content={metaKeywords} />
            <meta name="description" content={metaDescription} />
          </Helmet>

          <ListingHero
            siteLabel={siteLabel}
            description="Here are the blog posts and tutorial series that match your search."
            primaryStat={blogCount}
            primaryStatLabel="Blog results"
            secondaryStat={tutCount}
            secondaryStatLabel="Tutorial results"
            primaryCtaTo="/"
            primaryCtaLabel="Home"
            secondaryCtaTo="/tutorialseries"
            secondaryCtaLabel="All tutorials"
          />

          <div
            className="text-center mt-2 d-flex flex-wrap justify-content-center gap-2"
            data-aos="fade-down"
          >
            {hasBlogPosts ? (
              <button
                type="button"
                className={`btn ${
                  activeTab === "blog" ? "btn-accent" : "btn-outline-primary"
                } m-1 rounded-pill px-4`}
                onClick={() => setActiveTab("blog")}
              >
                <center style={{ fontSize: "28px", fontFamily: "sofia" }}>
                  <b>
                    Blo<b style={{ color: "#173a9b" }}>g's </b>
                  </b>
                </center>
              </button>
            ) : null}
            {hasTutorialSeries ? (
              <button
                type="button"
                className={`btn ${
                  activeTab === "tutorial"
                    ? "btn-accent"
                    : "btn-outline-primary"
                } m-1 rounded-pill px-4`}
                onClick={() => setActiveTab("tutorial")}
              >
                {" "}
                <center style={{ fontSize: "28px", fontFamily: "sofia" }}>
                  <b>
                    Tuto<b style={{ color: "#173a9b" }}>rial's </b>
                  </b>
                </center>
              </button>
            ) : null}
          </div>

          {activeTab === "blog" && hasBlogPosts ? (
            <div className="row g-4 home-card-grid justify-content-center">
              {data.blog_posts.map((blog, index) => {
                const newTypeDate = dataFormatter(blog.published_date);

                const limitedContent = (() => {
                  const parser = new DOMParser();
                  const plainText =
                    parser.parseFromString(blog.post_content, "text/html").body
                      .textContent || "";
                  const letterOnlyText = plainText.replace(/[^a-zA-Z ]/g, "");
                  let letterCount = 0;
                  let limitedText = "";
                  for (let i = 0; i < letterOnlyText.length; i++) {
                    if (/[a-zA-Z]/.test(letterOnlyText[i])) {
                      letterCount++;
                    }
                    if (letterCount <= 200) {
                      limitedText += letterOnlyText[i];
                    } else {
                    }
                  }
                  return limitedText + (letterCount > 200 ? "..." : "");
                })();

                return (
                  <div
                    className="col-12 col-xl-6 card_box"
                    key={blog.post_id}
                    data-aos="fade-up"
                    data-aos-delay={0}
                  >
                    <article className="card home-card h-100">
                      <div className="home-card__body">
                        <div className="home-card__thumb">
                          <CardImageThumb
                            src={blog.post_banner_b64}
                            alt={blog.post_title}
                            onOpen={setImageLightboxSrc}
                          />
                        </div>
                        <div className="home-card__content">
                          <Link
                            to={`/read/${toSlug(blog.post_title)}`}
                            state={{ blog }}
                            onClick={() =>
                              localStorage.setItem("post_id", blog.post_id)
                            }
                            className="home-card__title"
                          >
                            {blog.post_title}
                          </Link>
                          <div
                            className="home-card__excerpt para_font_family"
                            dangerouslySetInnerHTML={renderHTML(limitedContent)}
                          />
                          <Link
                            to={`/read/${toSlug(blog.post_title)}`}
                            state={{ blog }}
                            onClick={() =>
                              localStorage.setItem("post_id", blog.post_id)
                            }
                            className="home-card__read"
                          >
                            Read more →
                          </Link>
                        </div>
                      </div>
                      <div className="home-card__tags">
                        <div className="tags-container">
                          {blog.tags.map((tag) => (
                            <Link
                              key={tag.tag_id}
                              to={`/blog/tag/${toSlug(tag.tag_name)}`}
                              state={{ blog }}
                              className="tag-link"
                            >
                              <button type="button" className="tag-button">
                                {tag.tag_name} ({tag.posts_count})
                              </button>
                            </Link>
                          ))}
                        </div>
                      </div>
                      <div className="home-card__footer">
                        <div className="home-card__footer-inner para_font_family text-light">
                          <p style={{ textTransform: "capitalize" }}>
                            <b>By</b> {blog?.name}
                          </p>
                          <p>
                            <b>On</b> {newTypeDate}
                          </p>
                        </div>
                      </div>
                    </article>
                  </div>
                );
              })}
            </div>
          ) : activeTab === "blog" ? (
            <div className="text-center py-4">
              <b className="heading_font fs-4">No blog posts in results</b>
            </div>
          ) : null}

          {activeTab === "tutorial" && hasTutorialSeries ? (
            <div className="row g-4 home-card-grid justify-content-center">
              {data.tutorial_series.map((tutorial, index) => {
                const limitedContentTutorials = (() => {
                  const parser = new DOMParser();
                  const plainText =
                    parser.parseFromString(
                      tutorial.tutorial_series_description,
                      "text/html",
                    ).body.textContent || "";
                  const letterOnlyText = plainText.replace(/[^a-zA-Z ]/g, "");
                  let letterCount = 0;
                  let limitedText = "";
                  for (let i = 0; i < letterOnlyText.length; i++) {
                    if (/[a-zA-Z]/.test(letterOnlyText[i])) {
                      letterCount++;
                    }
                    if (letterCount <= 200) {
                      limitedText += letterOnlyText[i];
                    } else {
                      break;
                    }
                  }
                  return limitedText + (letterCount > 200 ? "..." : "");
                })();

                return (
                  <div
                    className="col-12 col-xl-6 card_box"
                    key={tutorial.id}
                    data-aos="fade-up"
                    data-aos-delay={0}
                  >
                    <article className="card home-card h-100">
                      <div className="home-card__body">
                        <div className="home-card__thumb">
                          <CardImageThumb
                            src={tutorial.tutorial_series_image_b64}
                            alt={tutorial.tutorial_series_name}
                            onOpen={setImageLightboxSrc}
                          />
                        </div>
                        <div className="home-card__content">
                          <Link
                            to={`/tutorial/${toSlug(
                              tutorial.tutorial_series_name,
                            )}`}
                            state={{ tutorial }}
                            className="home-card__title"
                          >
                            {tutorial.tutorial_series_name}
                          </Link>
                          <div
                            className="home-card__excerpt para_font_family"
                            dangerouslySetInnerHTML={renderHTML(
                              limitedContentTutorials,
                            )}
                          />
                          <Link
                            to={`/tutorial/${toSlug(
                              tutorial.tutorial_series_name,
                            )}`}
                            state={{ tutorial }}
                            className="home-card__read"
                          >
                            Open series →
                          </Link>
                        </div>
                      </div>
                      <div className="home-card__footer">
                        <div className="home-card__footer-inner para_font_family text-light">
                          <p style={{ textTransform: "capitalize" }}>
                            <b>Lessons</b> {tutorial.lessons_count}
                          </p>
                          <p style={{ textTransform: "capitalize" }}>
                            <b>Tech</b> {tutorial.technologies}
                          </p>
                        </div>
                      </div>
                    </article>
                  </div>
                );
              })}
            </div>
          ) : activeTab === "tutorial" ? (
            <div className="text-center py-4">
              <b className="heading_font fs-4">No tutorials in results</b>
            </div>
          ) : null}

          {imageLightboxSrc ? (
            <Lightbox
              mainSrc={imageLightboxSrc}
              onCloseRequest={() => setImageLightboxSrc(null)}
            />
          ) : null}
        </div>
      ) : (
        <NotFound />
      )}
    </div>
  );
}
